import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box, Grid, Typography } from '@material-ui/core'

import { DashboardChartPaper, DashboardTable, DonutChart } from 'components'

import theme from 'theme'
import useStyles from './styles'
import constants from 'constants/index'

const Safeguard = ({ isLoading = false, safeguard = {} }) => {
  const {
    LIFECYCLE_DISCARD_MODE_TABLE,
    LIFECYCLE_RECOVERY_TABLE,
    LIFECYCLE_ASSET_INVENTORY_CATEGORY_TABLE,
  } = constants.dataIntelligence
  const { DATA_PROTECTION_IDS, SHARE_TYPE_IDS } = constants.dataCollected

  const classes = useStyles()

  const allocationValues = SHARE_TYPE_IDS.map(
    (id) =>
      safeguard?.allocationModes?.find((item) => item?.id === id)?.quantity ||
      0,
  )

  const protectionValues = DATA_PROTECTION_IDS.map(
    (id) =>
      safeguard?.protectionModes?.find((item) => item?.id === id)?.quantity ||
      0,
  )

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      <Typography variant="h5" color="primary">
        Salvaguarda e ciclo de vida
      </Typography>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={6}
          lg={4}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardTable
            emptyMessage="Nenhuma categoria de ativos encontrada."
            rows={safeguard?.assetInventoryCategories}
            columns={LIFECYCLE_ASSET_INVENTORY_CATEGORY_TABLE}
            isLoading={isLoading}
            hasPaper
            tableHeadProps={{ className: classes.tableHead }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={4}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardTable
            emptyMessage="Nenhum disposição de dados encontrada."
            rows={safeguard?.discardModes}
            columns={LIFECYCLE_DISCARD_MODE_TABLE}
            isLoading={isLoading}
            hasPaper
            tableHeadProps={{ className: classes.tableHead }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          lg={4}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardTable
            emptyMessage="Nenhuma forma de recuperação encontrada."
            rows={safeguard?.recoveryModes}
            columns={LIFECYCLE_RECOVERY_TABLE}
            isLoading={isLoading}
            hasPaper
            tableHeadProps={{ className: classes.tableHead }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardChartPaper
            title="Ambiente de alocação"
            subtitle="Dados alocados interna e externamente"
            isLoading={isLoading}
          >
            <DonutChart
              legendShow
              names={['Interno', 'Externo', 'Ambos']}
              values={allocationValues}
              title="Ambiente de alocação"
              colors={[
                theme.palette.dashboard.chart.primary.approved,
                theme.palette.dashboard.chart.primary.pending,
                theme.palette.grapePurple,
              ]}
              showName={false}
            />
          </DashboardChartPaper>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardChartPaper
            title="Forma de proteção"
            subtitle="Meios de proteção físicos e eletrônicos dos dados"
            isLoading={isLoading}
          >
            <DonutChart
              legendShow
              names={['Físico', 'Eletrônico', 'Ambos']}
              values={protectionValues}
              title="Forma de proteção"
              colors={[
                theme.palette.dashboard.chart.primary.approved,
                theme.palette.dashboard.chart.primary.pending,
                theme.palette.dashboard.chart.primary.revision,
              ]}
              showName={false}
            />
          </DashboardChartPaper>
        </Grid>
      </Grid>
    </Box>
  )
}

Safeguard.propTypes = {
  isLoading: PropTypes.bool,
  safeguard: PropTypes.object,
}

export default Safeguard
